import React from 'react';

import { NewTextField as TextField } from '@lp/ds-next';
import { Flex, Typography } from 'antd';
import { useParams } from 'react-router-dom';

import ChangePartnerServiceLevel from './ChangePartnerServiceLevel';
import usePartnerServiceLevel from '../../../serviceLevels/hooks/usePartnerServiceLevel';
import { IPartnerV3, IPartnerV3Update } from '../models/partnerV3';
import Loader from '@/components/Loader';

const { Text } = Typography;

const PartnerServiceLevel = ({
  partner,
  updatePartner,
}: {
  partner: IPartnerV3;
  updatePartner: (data: IPartnerV3Update) => Promise<{ success: boolean }>;
}) => {
  const { id } = useParams<{ id: string }>();
  const { result, invalidate: fetchPartnerServiceLevel } =
    usePartnerServiceLevel(id!);
  if (result.state === 'idle' || result.state === 'loading') {
    return <Loader size={32} />;
  }

  if (result.state === 'error') return <>Error fetching service level.</>;

  const { resource: serviceLevel } = result;

  return (
    <Flex align="flex-start" gap="1rem">
      <Flex vertical align="flex-start" gap="1rem" style={{ width: '70%' }}>
        <Flex gap="0.5rem">
          <Text strong style={{ textTransform: 'uppercase' }}>
            Name:
          </Text>
          <Text>{serviceLevel.name}</Text>
        </Flex>
        <Flex align="flex-start" gap="0.5rem">
          <Text strong style={{ textTransform: 'uppercase' }}>
            Description:
          </Text>
          <Text>{serviceLevel.description}</Text>
        </Flex>
        <Text strong style={{ textTransform: 'uppercase' }}>
          Box configuration:
        </Text>
        <TextField
          multiline
          rows={40}
          fullWidth
          placeholder="Box Configuration"
          name="boxConfiguration"
          value={JSON.stringify(serviceLevel.boxConfiguration, null, 2)}
          disabled
        />
      </Flex>
      <Flex gap="0.5rem" style={{ width: '30%' }}>
        <ChangePartnerServiceLevel
          currentServiceLevel={serviceLevel}
          fetchPartnerServiceLevel={fetchPartnerServiceLevel}
          partner={partner}
          updatePartner={updatePartner}
        />
      </Flex>
    </Flex>
  );
};

export default PartnerServiceLevel;
